/*
* Copyright (C) GMS Inc - All Rights Reserved
* This file is part of GMSCloud. - Proprietary and confidential
* Unauthorized copying of this file, via any medium is strictly prohibited
* 
* Created on   : 
* @author      : Kanimozhi.S
* @since       : 0.0.1
* Requirement# :
* Purpose      : Features Configuration 
* -----------------------------------------------------------------------------
* Revision History
* -----------------------------------------------------------------------------
* Requirement/
* Issue/WorkItem |   DATE        |   AUTHOR     |   DESCRIPTION OF CHANGE
* -----------------------------------------------------------------------------
* 4037           |  01-04-2025   |   Kanimozhi  | List the Third party service Configuration and add new properties ui implementation and data bind 
* 4656           |  17-05-2025   |   Kanimozhi  | Fix the multiple time  click to save
*
*
*/
import * as React from "react";
import { Grid, Card, Typography, Button, TextField, Box, IconButton, Tooltip } from "@mui/material";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import CustomDialog from "../Dialog";
import { createServiceServicesConfiguration, getByServicesConfiguration } from "../../services/ExternalService";
import { useOidcAccessToken } from "@axa-fr/react-oidc";
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useState } from "react";



const ThirdPartyConfiguration: React.FC<any> = (props) => {
  console.log(props, 'props');


  const [openConfirmDialog, setOpenConfirmDialog] = React.useState<boolean>(false);
  const [createSuccess, setCreateSuccess] = React.useState<boolean>(false);
  const [error, setError] = React.useState<boolean>(false);
  const { accessToken, accessTokenPayload } = useOidcAccessToken();
  const [errorMessage, setErrorMessage] = React.useState<any>(null);
  const [isSaving, setIsSaving] = useState(false);
  const [parsedData, setParsedData] = React.useState<any[]>([]);
  const [newFields, setNewFields] = React.useState<any[]>([]);
  const [showUnmaskedFields, setShowUnmaskedFields] = React.useState<{ [key: string]: boolean }>({});

  React.useEffect(() => {
    fetchData();
  }, []);


const isFieldValid = () => {
  const allParsedFieldsValid = parsedData.every(item =>
    Object.entries(item).every(([key, value]) => {
      if (key === "invalid" || key === "version") return true;
      return value !== null && value !== undefined && value !== "";
    })
  );

  const allNewFieldsValid = newFields.every(
    (field) => field.key && field.value
  );

  const hasAnyFields = parsedData.length > 0 || newFields.length > 0;

  return allParsedFieldsValid && allNewFieldsValid && hasAnyFields;
};



  const fetchData = async () => {
    try {
      const res = await getByServicesConfiguration(accessToken, props.serviceId);
      let parsed: any[] = [];

      if (res && res.data && res.data.length > 0) {
        const credentialEntry = res.data.find((item: any) => item.key === "EagleView.credential");

        if (credentialEntry) {
          const credentialData = credentialEntry.data;
          parsed = Object.entries(credentialData).map(([key, value]) => ({ [key]: value }));
        }
      }

      if (props.serviceName === "EagleView") {
        const defaultFields = [
          { ClientId: null },
          { ClientKey: null },
        ];

        const existingKeys = parsed.flatMap(obj => Object.keys(obj));
        defaultFields.forEach(field => {
          const key = Object.keys(field)[0];
          if (!existingKeys.includes(key)) {
            parsed.push(field);
          }
        });
      }
      setParsedData(parsed);
    } catch (error) {
      console.error("Error fetching service configuration:", error);
    }
  };

  const handleSave = async () => {
    if (isSaving) return;
    setIsSaving(true); 
    const newFormattedFields = newFields.map(field => ({
      [field.key]: field.value,
    }));
    const allData = [...parsedData, ...newFormattedFields];
    const mergedData: { [key: string]: any } = {};
    allData.forEach(obj => {
      const key = Object.keys(obj)[0];
      mergedData[key] = obj[key];
    });
    const payload = {
      key: props.serviceName,
      data: mergedData,
      createdBy: accessTokenPayload.oid,
      invalid: false,
      serviceMaster: props.serviceId,
    };
    try {
      const response = await createServiceServicesConfiguration(payload, accessToken);
      const Status = "Success";
      if (response?.data === Status) {

        setOpenConfirmDialog(true);
        setCreateSuccess(true);
        // await fetchData();
        setError(false);
      }
      else if (response.data !== Status) {
        setOpenConfirmDialog(true);
        setCreateSuccess(false);
        setError(true);
        setErrorMessage(response.message);
      }
      else {
        setOpenConfirmDialog(true);
        setCreateSuccess(false);
        setError(true);
      }
    } catch (error) {
      console.error("Error saving configuration", error);
    } finally {
      setIsSaving(false);
    }
  };
  const handleNewFieldChange = (index, fieldType, value) => {
    const updatedFields = [...newFields];
    updatedFields[index][fieldType] = value;
    setNewFields(updatedFields);
  };


  const handleAddNewField = () => {
    setNewFields([...newFields, { key: "", value: "" }]);
  };

  return (

    <Card sx={{ width: "100%", overflowY: "auto", p: 3 }}>
      <Grid>
        <Grid item xs={12}>
          <Card sx={{ p: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", mb: 3 }}>
              <Typography variant="h5" color="textSecondary">
                Properties
              </Typography>
              <Button
                variant="contained"
                sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "auto", minWidth: "40px", px: 1.5, py: 0.75 }}
                onClick={handleAddNewField}
              >
                <AddOutlinedIcon sx={{ fontSize: "1.2rem", mr: 0.5 }} />
                Add New Propertie
              </Button>
            </Box>



            {parsedData?.length > 0 && parsedData?.map((item, itemIndex) => (
              Object.entries(item)
                .filter(([key]) => key !== 'invalid' && key !== 'version')
                .map(([key, value], fieldIndex) => (
                  <Grid container spacing={2} key={`${itemIndex}-${fieldIndex}`} sx={{ mb: 2, alignItems: "center" }}>
                    <Grid item xs={3}>
                      <Typography variant="h5" sx={{ mt: 1 }}>
                        {key} :
                      </Typography>
                    </Grid>
                    <Grid item xs={5} sx={{ display: "flex", alignItems: "center" }}>
                      <TextField
                        fullWidth
                        size="small"
                        value={
                          (key === 'ClientId' || key === 'ClientKey') && !showUnmaskedFields[key] ? value: value
                        }
                        onFocus={() => {
                          if (key === 'ClientId' || key === 'ClientKey') {
                            setShowUnmaskedFields(prev => ({ ...prev, [key]: true }));
                          }
                        }}
                        onBlur={() => {
                          if (key === 'ClientId' || key === 'ClientKey') {
                            setShowUnmaskedFields(prev => ({ ...prev, [key]: false }));
                          }
                        }}
                        onChange={(e) => {
                          const updatedData = [...parsedData];
                          updatedData[itemIndex][key] = e.target.value;
                          setParsedData(updatedData);
                        }}
                      />
                      {(key === 'ClientId' || key === 'ClientKey') && (
                        <IconButton
                          onClick={() => {
                            setShowUnmaskedFields(prev => ({
                              ...prev,
                              [key]: !prev[key],
                            }));
                          }}
                          sx={{ ml: 1 }}
                        >
                        </IconButton>
                      )}
                    </Grid>
                    <Grid item xs={0} sx={{ display: "flex", justifyContent: "center" }}>
                      <Tooltip title="Delete">
                        <IconButton
                          onClick={() => {
                            const updatedData = [...parsedData];
                            delete updatedData[itemIndex][key];
                            setParsedData(updatedData);
                            

                          }}
                        >
                          <DeleteRoundedIcon />
                        </IconButton>
                      </Tooltip>
                    </Grid>
                  </Grid>
                ))
            ))}

            {newFields.map((field, index) => (
              <Grid item xs={12} key={`new-${index}`}>
                <Grid container spacing={2} sx={{ mb: 2, alignItems: "center" }}>
                  <Grid item xs={3}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder=""
                      value={field.key}
                      onChange={(e) => handleNewFieldChange(index, "key", e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={5}>
                    <TextField
                      fullWidth
                      size="small"
                      placeholder=""
                      value={field.value}
                      onChange={(e) => handleNewFieldChange(index, "value", e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={0} sx={{ display: "flex", justifyContent: "center" }}>
                    <Tooltip title="Delete">
                      <IconButton
                        onClick={() => {
                          const updatedNewFields = [...newFields];
                          updatedNewFields.splice(index, 1); // Remove by index
                          setNewFields(updatedNewFields);
                        }}
                      >
                        <DeleteRoundedIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                </Grid>
              </Grid>
            ))}
          </Card>
        </Grid>


        <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "green",
              color: "white",
              "&:hover": {
                backgroundColor: "darkgreen",
              },
            }}
            onClick={handleSave}
                disabled={!isFieldValid() || isSaving}
             >
            {isSaving ? "Saving Configuration..." : "Save"}
          </Button>
        </Grid>
      </Grid>

      <CustomDialog
        open={openConfirmDialog}
        onClose={() => setOpenConfirmDialog(false)}
        success={createSuccess}
        error={error}
        reason={errorMessage}
        Content={createSuccess ? "configuration was added successfully." : "Failed to save configuration, try later"}
      />
    </Card>

  );
};

export default ThirdPartyConfiguration;










